import builder from '../builder';
import Pencil2 from '../../streamline-icons/bold/pencil-2.svg';

export default builder('IconPencil2Bold', Pencil2);
